import { GameVars } from "../../GameVars";
import { GameConstants } from "../../GameConstants";
import { MazeManager } from "./MazeManager";

export class CursorController {

    private static readonly SWIPE_RATIO = 3.5;

    private scene: Phaser.Scene;
    private cursors: any;
    private timeDown: number;
    private downX: number;
    private downY: number;
    private leftIsUp: boolean;
    private rightIsUp: boolean;
    private uptIsUp: boolean;
    private downIsUp: boolean;
    private swipeInput: any;

    constructor(scene: Phaser.Scene) {

        this.scene = scene;

        if (this.scene.game.device.input.touch) {

            this.cursors = null;

            const scene = <any> this.scene;

            this.swipeInput = scene.rexGestures.add.swipe();

            this.swipeInput.on("swipe", function (swipe: any): void {

                if (GameVars.gameOver) {
                    return;
                }

                if (swipe["left"]) {
                    MazeManager.moveCursor(GameConstants.DIR_LEFT);
                }
    
                if (swipe["right"]) {
                    MazeManager.moveCursor(GameConstants.DIR_RIGHT);
                }

                if (swipe["up"]) {
                    MazeManager.moveCursor(GameConstants.DIR_UP);
                }
    
                if (swipe["down"]) {
                    MazeManager.moveCursor(GameConstants.DIR_DOWN);
                }
    
            }, this);

        } else {

            this.cursors = this.scene.input.keyboard.createCursorKeys();

            this.leftIsUp = true;
            this.rightIsUp = true;
            this.uptIsUp = true;
            this.downIsUp = true;
        }
    }

    public update(): void {

        if (GameVars.levelCompleted || GameVars.gameOver || GameVars.pause || this.cursors === null) {
            return;
        }

        if (this.cursors.left.isDown && this.leftIsUp) {

            this.leftIsUp = false;
            MazeManager.moveCursor(GameConstants.DIR_LEFT);

        } else if (this.cursors.right.isDown && this.rightIsUp) {

            this.rightIsUp = false;
            MazeManager.moveCursor(GameConstants.DIR_RIGHT);

        } else if (this.cursors.up.isDown && this.uptIsUp) {

            this.uptIsUp = false;
            MazeManager.moveCursor(GameConstants.DIR_UP);

        } else if (this.cursors.down.isDown && this.downIsUp ) {

            this.downIsUp = false;
            MazeManager.moveCursor(GameConstants.DIR_DOWN);
        }

        if (this.cursors.left.isUp && !this.leftIsUp) {

            this.leftIsUp = true;
          
        } else if (this.cursors.right.isUp && !this.rightIsUp) {

            this.rightIsUp = true;

        } else if (this.cursors.up.isUp && !this.uptIsUp) {

            this.uptIsUp = true;
          
        } else if (this.cursors.down.isUp && !this.downIsUp ) {

            this.downIsUp = true;
        }
    }
}
